<template>
  <div>
    <v-btn icon @click.stop="uploads = !uploads" :class="{ 'nx-animation-bounce': processingFilesCount }"
           :title="$t('message.upload.activeUploads')">
      <v-icon :color="iconColor">import_export</v-icon>
    </v-btn>
    <nx-simple-dialog
      @close="uploads = false"
      :title="$t('message.upload.activeUploads')"
      :shown="uploads"
    >
      <div>
        <p> {{ $t('message.upload.processingFilesCount') }} {{ processingFilesCount }}</p>
        <p> {{ $t('message.upload.completedFilesCount') }} {{ completedFilesCount }}</p>
      </div>
      <div v-if="hasFiles">
        <nx-file-upload-list-item v-for="(file, index) in allFiles"
                                  :file="file"
                                  :isFileCompleted="completedFiles.indexOf(file) !== -1"
                                  @click="toVideoEdit(file)"
                                  :index="index"
                                  :key="file.filename + index">
          <v-divider v-if="index + 1 < allFiles.length"></v-divider>
        </nx-file-upload-list-item>
      </div>
      <v-layout align-center justify-center v-else>{{ $t('message.upload.noFiles')}}</v-layout>
    </nx-simple-dialog>
  </div>
</template>

<script>
import SimpleDialog from '@/components/dialogs/SimpleDialog.vue';
import { mapGetters } from 'vuex';
import toast from '@/modules/toast/services';
import FileUploadListItem from './FileUploadListItem';

export default {
  name: 'nx-file-upload-list',
  components: {
    [SimpleDialog.name]: SimpleDialog,
    [FileUploadListItem.name]: FileUploadListItem,
  },
  data() {
    return {
      uploads: false,
    };
  },
  computed: {
    ...mapGetters('upload', [
      'hasFiles',
      'allFiles',
      'completedFiles',
      'completedFilesCount',
      'processingFilesCount',
    ]),
    iconColor() {
      if (this.processingFilesCount > 0) {
        return 'accent';
      }
      return null;
    },
  },
  methods: {
    // eslint-disable-next-line consistent-return
    beforeUnloadHandler(event) {
      if (this.processingFilesCount > 0) {
        const msg = this.$t('message.upload.exitWhileUploadInProgress');
        toast.error(msg);
        event.returnValue = msg;
        return msg;
      }
    },
    toVideoEdit(fileUpload) {
      this.uploads = false;
      this.$router.push({
        name: 'content.editor',
        params: {
          type: fileUpload.type,
          id: fileUpload.contentId,
        },
      });
      this.$store.commit('upload/CLEAR_FILE_UPLOAD', fileUpload);
    },
  },
  mounted() {
    window.addEventListener('beforeunload', this.beforeUnloadHandler);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeUnloadHandler);
  },
};
</script>
